export default __webpack_public_path__ + "static/media/ellipses.b0c47826.svg";